import * as React from 'react';
import { Path } from 'react-native-svg';

function Eyebrows() {
  return (
    <Path d="M38.43 73.81A4 4 0 0042 75.6a3.35 3.35 0 001.81-.6 20.55 20.55 0 011.84-1.34 7.29 7.29 0 014.68-1.09 6.13 6.13 0 014.11 2.28.09.09 0 010 .13.14.14 0 01-.09 0 12.68 12.68 0 00-4.13-.71 10 10 0 00-3.93.6 20.25 20.25 0 00-1.89 1.07 4.4 4.4 0 01-6.11-2 .08.08 0 010-.11.09.09 0 01.14-.02zM99.36 76.55a4.42 4.42 0 01-3.71 2.57 4.34 4.34 0 01-2.41-.54 18 18 0 00-1.89-1.06 9.92 9.92 0 00-3.92-.61 13 13 0 00-4.14.71.1.1 0 01-.12-.05.1.1 0 010-.09 6.12 6.12 0 014.11-2.27A7.29 7.29 0 0192 76.3a20.57 20.57 0 011.84 1.33 3.35 3.35 0 001.82.63 4 4 0 003.56-1.78.09.09 0 01.12 0 .08.08 0 01.02.07zM45.42 77.6a10.79 10.79 0 00-3.62 1.05 11.17 11.17 0 013.38-2 .51.51 0 01.36.95zM93 79.38a11.17 11.17 0 013.38 2 10.79 10.79 0 00-3.62-1.05.52.52 0 01-.45-.56.51.51 0 01.56-.45h.12z" />
  );
}

export default Eyebrows;
